import { render } from "./OauthCreate.vue?vue&type=template&id=e9656f6c"
import script from "./OauthCreate.vue?vue&type=script&lang=js"
export * from "./OauthCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__